import { getLocalStorage } from 'libs/utils/logic/ui/systemLogic';
import { apiEndpoint } from 'static/api/endpoint';
import { LOCAL_STORAGE_AUTH_HEADER_KEY } from 'static/config/coreConfig';

export function apiUploadFile(formdata: FormData): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);
    return apiEndpoint('POST', '/api/v1/upload/image', null, formdata, {
        ...(authToken ? { Authorization: authToken } : {}),
        'content-type': 'multipart/form-data'
    });
}

export function apiUploadImportFile(formdata: FormData): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);
    return apiEndpoint('POST', '/api/v1/upload/import', null, formdata, {
        ...(authToken ? { Authorization: authToken } : {}),
        'content-type': 'multipart/form-data'
    });
}

export function apiUploadAudioFile(formdata: FormData): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);

    return apiEndpoint('POST', '/api/v1/upload/file', null, formdata, {
        ...(authToken ? { Authorization: authToken } : {}),
        'content-type': 'multipart/form-data'
    });
}

export function apiSubscriptionCreatePortalLink(): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);

    return apiEndpoint('POST', '/api/v1/subscription/create-customer-portal-session', null, null, {
        ...(authToken ? { Authorization: authToken } : {}),
        'Content-Type': 'application/json'
    });
}

export function apiSubscriptionCreateSubscribeLink(
    subscription: 'creator' | 'pro'
): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);

    return apiEndpoint(
        'POST',
        '/api/v1/subscription/create-checkout-session',
        null,
        { subscription },
        {
            ...(authToken ? { Authorization: authToken } : {}),
            'Content-Type': 'application/json'
        }
    );
}

interface IGenerateCalendarEventPayload {
    guideId: string;
    guideProgramItemId: string;
    timezone: string;
}

export function apiCreateProgramItemEvent(
    data: IGenerateCalendarEventPayload
): Promise<Record<string, unknown>> {
    const authToken = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);

    return apiEndpoint('POST', '/api/v1/calendar/generate-program-item-event', null, data, {
        ...(authToken ? { Authorization: authToken } : {}),
        'Content-Type': 'application/json'
    });
}
